module.exports = __webpack_public_path__ + "static/media/calendarIcon.2744bcb4.svg";